import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Spinner, Popup } from "../../../../ui-kit";

import DefectCardFile from "../defectCardFile/defectCardFile";
import defectCardsStore from "../../../../store/defectCards";

import styles from "./DefectUploadFileItem.module.scss";
import FileApi, { getFileMimeType } from "../../../../api/Files";
import {
  ExcelIco,
  PaperIco,
  PdfIco,
  WordIco,
} from "../../../../assets/customIcons";
import UploadItemPreview from "../../../../ui-kit/UploadFile/UploadItemPreview";
import { toJS } from "mobx";

interface DefectUploadFileItemProps {
  file: any;
}

const DefectUploadFileItem: FC<DefectUploadFileItemProps> = observer(
  ({ file }) => {
    const [fileForPreview, setFileForPreview] = useState(file);

    useEffect(() => {
      FileApi.getFileByGuid(file.guid).then((res) => {
        setFileForPreview((prev) => ({
          ...prev,
          thumbUrl: URL.createObjectURL(res.data),
        }));
      });
    }, [file.guid]);

    return fileForPreview.thumbUrl ? (
      <UploadItemPreview file={fileForPreview} canDelete={false} />
    ) : (
      ""
    );
  },
);

export default DefectUploadFileItem;
